import React, { useEffect } from 'react';
import styled from 'styled-components';

import BasketToggle from './Buttons/BasketToggle';
import ChatToggle from './Buttons/ChatToggle';
import ReactionToggle from './Buttons/ReactionToggle';
import { heartAnimation } from '../../util/util';
import { useConfiguration } from '../../contexts/ConfigurationContext';

const Container = styled.div`
	qplayer-embed .qplayer-app & {
		height: 100%;
		width: 15%;
		opacity: 100%;
		display: flex;
		flex-direction: column-reverse;
		pointer-events: none;
		padding-bottom: 25px;
        color: #ffffff;
		@media screen and (max-width: 992px) and (orientation: landscape) and (hover: none) and (pointer: coarse) {
			width: auto;
		}
	}
`;

interface ChatButtonsWrapperProps {
    settings: any;
    basketItemCount: number;
    handleReactionPost?: () => void;
    reactionId?: string;
    isShowViewerEngagementModule: boolean;
}

const ChatButtonsWrapper: React.FC<ChatButtonsWrapperProps> = ({ settings, basketItemCount, handleReactionPost, reactionId, isShowViewerEngagementModule }) => {
    const configParams = useConfiguration().configParams;
    useEffect(() => {
        if (!reactionId) {
            return;
        }

        heartAnimation('bottomControlbarHearts--mobile', configParams?.container);
    }, [reactionId, configParams?.container]);

    return (
        <>
            {settings.engagementFeatures.enabled && (
                <Container style={{ userSelect: 'none' }}>
                    {settings.engagementFeatures.showChat && isShowViewerEngagementModule && <ChatToggle />}
                    {settings.engagementFeatures.showShoppingCart && (
                        <BasketToggle color={settings?.playerStyling?.primaryColor ?? '#126cfc'} basketItemCount={basketItemCount} />
                    )}
                    {settings.engagementFeatures.showLiveLikes && (
                        <ReactionToggle
                            heartAnimation={() => {
                                heartAnimation('bottomControlbarHearts--mobile', configParams?.container);
                                handleReactionPost?.();
                            }}
                            container={
                                <div
                                    className="bottomControlbarHearts--mobile"
                                    style={{ position: 'absolute', left: '30%', userSelect: 'none' }}
                                    tabIndex={-1}
                                />
                            }
                        />
                    )}
                </Container>
            )}
        </>
    );
};

export { ChatButtonsWrapper };
